import { render, staticRenderFns } from "./CheckoutItems.vue?vue&type=template&id=7e7b66f6"
import script from "./CheckoutItems.vue?vue&type=script&lang=js"
export * from "./CheckoutItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports